import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Box, FlexBox, FormDialog, Grid, Icon, Typography } from '@kis-technologies/kis-ui';
import { useStyles } from '../styled';

interface SettlementReportOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (payload: { fromDate: string | null; toDate: string | null }) => void;
}

export const SettlementReportOverlay = ({ isOpen, onClose, onApply }: SettlementReportOverlayProps) => {
  const classes = useStyles({ isOpen })();

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  useEffect(() => {
    if (isOpen) {
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      firstDay.setHours(0, 0, 0, 0);

      setStartDate(firstDay);
      setEndDate(now);
    }
  }, [isOpen]);

  const handleApply = () => {
    onApply({
      fromDate: startDate ? startDate.toISOString() : null,
      toDate: endDate ? endDate.toISOString() : null
    });

    onClose();
  };

  const disableApply = !startDate || !endDate;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const DatePickerCustomInput = React.forwardRef((props1: any, ref: any) => {
    return (
      <div
        onClick={props1.onClick}
        ref={ref}
        className={classes.datePickerInput}
        style={{ padding: props1.value ? '0 40px 0 12px' : '0 12px' }}
      >
        <label>{props1.value || props1.placeholder}</label>
        <Icon name="CalendarToday" sx={{ color: '#F46D2E' }} />
      </div>
    );
  });

  return (
    <FormDialog
      open={isOpen}
      title="Settlement Report"
      cancelButtonText="Cancel"
      confirmButtonText="Build Report"
      cancelButtonAction={onClose}
      confirmButtonAction={handleApply}
      confirmButtonDisabled={disableApply}
    >
      <Grid direction="column" width="100%" marginTop="10px">
        <FlexBox className={classes.filtersFieldsFlexBox}>
          {/* Start Date */}
          <Box className={classes.filtersFieldBox}>
            <Typography className={classes.filtersFieldLabel}>Start Date and Time</Typography>
            <div className="my-datepicker-wrapper">
              <div className={classes.datePickerContainer}>
                <DatePicker
                  showTimeSelect
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  placeholderText="MM/DD/YYYY hh:mm aa"
                  dateFormat="MM/dd/yyyy h:mm aa"
                  className={classes.datePickerComponent}
                  isClearable
                  customInput={<DatePickerCustomInput />}
                  calendarClassName="my-custom-calendar"
                  popperProps={{ strategy: 'fixed' }}
                />
              </div>
            </div>
          </Box>

          {/* End Date */}
          <Box className={classes.filtersFieldBox}>
            <Typography className={classes.filtersFieldLabel}>End Date and Time</Typography>
            <div className="my-datepicker-wrapper">
              <div className={`${classes.datePickerContainer} ${classes.rightDatePickerContainer}`}>
                <DatePicker
                  showTimeSelect
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  placeholderText="MM/DD/YYYY hh:mm aa"
                  dateFormat="MM/dd/yyyy h:mm aa"
                  className={classes.datePickerComponent}
                  isClearable
                  customInput={<DatePickerCustomInput />}
                  calendarClassName="my-custom-calendar"
                  popperProps={{ strategy: 'fixed' }}
                />
              </div>
            </div>
          </Box>
        </FlexBox>
      </Grid>
    </FormDialog>
  );
};
